import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import Select from 'react-select';

import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';

import AppNavbar from "./AppNavbar"

const RestaurantUpdate = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [donationData, setDonationData] = useState({
    id: "",
    receipt_no: "",
    date: "",
    name: "",
    city: "",
    type_of_donation: "",
    type_of_contribution: null,
    credited_amount: "",
    depositor: "",
    contribution_id: null
  });

  const [loading, setLoading] = useState(false);

  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [depositorNames, setdepositorNames] = useState([]);
  const [contributionOptions, setContributionOptions] = useState([]);

  useEffect(() => {
    if (localStorage.getItem('login')) {
      console.warn("hello")
    } else {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchCities = fetch('https://hospital.rozeetechnist.com/hospital-api/getCities.php').then(r => r.json());
    const fetchDepositor = fetch('https://hospital.rozeetechnist.com/hospital-api/getDepositors.php').then(r => r.json());
    const fetchContributions = fetch('https://hospital.rozeetechnist.com/hospital-api/getContributions.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ start: 1, per_page: 500 })
    }).then(r => r.json());
    const fetchDonation = fetch("https://hospital.rozeetechnist.com/hospital-api/getDonation.php", {
      method: "Post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id })
    }).then(r => r.json());

    Promise.all([fetchCities, fetchDepositor, fetchContributions, fetchDonation]).then(([citiesResult, depositorsResult, contribResult, donationResult]) => {
      setDropdownOptions(citiesResult || []);
      setdepositorNames(depositorsResult || []);
      const options = (contribResult.data && contribResult.data.length)
        ? contribResult.data.map((c) => ({ value: c.id, label: `${c.title} - ${c.amount}`, amount: parseFloat(c.amount) || 0 }))
        : [];
      setContributionOptions(options);

      if (donationResult.data) {
        const d = donationResult.data;
        const selectedContribution = (d.contribution_id && options.length) ? options.find((o) => o.value === d.contribution_id) || null : null;
        setDonationData({
          id: d.id,
          receipt_no: d.receipt_no,
          date: d.date,
          name: d.name,
          city: d.city,
          type_of_donation: d.type_of_donation,
          type_of_contribution: selectedContribution,
          credited_amount: d.credited_amount,
          depositor: d.depositor || "",
          contribution_id: d.contribution_id || null
        });
      }
    }).catch((error) => {
      console.error('Error loading data:', error);
    });
  }, [id]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setDonationData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSelectChange = (selectedOption) => {
    setDonationData((prevData) => ({
      ...prevData,
      city: selectedOption, // Store only the value property
    }));
  };


  const handleUpdate = () => {
    // Get logged user id from localStorage
    const loginData = localStorage.getItem('login');
    let loggedUserId = null;

    if (loginData) {
      try {
        const user = JSON.parse(loginData);
        loggedUserId = user.id;
      } catch (error) {
        console.error('Error parsing login data:', error);
      }
    }

    if (!loggedUserId) {
      toast.error('User session expired. Please login again.');
      navigate('/login');
      return;
    }

    setLoading(true);

    // Prepare data with updated_by; send contribution_id for Type of Contribution
    const updateData = {
      ...donationData,
      updated_by: loggedUserId,
      contribution_id: donationData.type_of_contribution?.value ?? donationData.contribution_id ?? null
    };

    fetch("https://hospital.rozeetechnist.com/hospital-api/updateDonation.php", {
      method: "Post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(updateData)
    }).then((result) => {
      result.json().then((resp) => {
        if (resp.status) {
          setLoading(false);
          toast.success(resp.message);
          navigate("/list");
        } else {
          toast.error(resp.message);
          setLoading(false);
        }
      })
    }).catch((error) => {
      console.error('Error updating donation:', error);
      toast.error('An error occurred. Please try again.');
      setLoading(false);
    });
  }

  const handleDepositorChange = (selectedOption) => {
    setDonationData((prevData) => ({
      ...prevData,
      depositor: selectedOption,
    }));
  };

  const handleContributionChange = (selectedOption) => {
    setDonationData((prevData) => ({
      ...prevData,
      type_of_contribution: selectedOption,
    }));
  };

  return (
    <div>
      <AppNavbar />
      <div className="container">
        <div className="row top-page-bar">
          <div className="col-9">
            <div className="main-title">
              <h1>Update Donation Receipt</h1>
            </div>
          </div>
          <div className="col-3">
            <div className="search-area">
              <div className="buttons">
                <Link className='btn btn-secondary' to="/list">Back</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">Receipt No.</label>
            <div>
              <input className="form-control" value={donationData.receipt_no} name="receipt_no" onChange={handleChange} placeholder='પહોચ ન.' />
            </div>
          </div>
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <div>
              <DatePicker
                className='form-control'
                selected={donationData.date}
                onChange={(date) => setDonationData(prevData => ({ ...prevData, date: date }))}
                dateFormat="dd/MM/yyyy"
                placeholderText='તારીખ'
              />
            </div>
          </div>
          <div className='col-md-12'></div>
          <div className="col-md-3">
            <label className="form-label">Name</label>
            <input className="form-control" value={donationData.name} name="name" onChange={handleChange} placeholder='નામ' />
          </div>
          <div className="col-md-3">
            <label className="form-label">City/Village</label>
            <Select
              value={donationData.city}
              name="city"
              onChange={handleSelectChange}
              options={dropdownOptions}
              placeholder="ગામ"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Type of Contribution</label>
            <Select
              value={donationData.type_of_contribution}
              name="type_of_contribution"
              onChange={handleContributionChange}
              options={contributionOptions}
              placeholder="Select Contribution"
              isClearable
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Type of Donation</label>
            <div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type_of_donation"
                  id="imdad"
                  value="imdad"
                  checked={donationData.type_of_donation === 'imdad'}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="imdad">
                  ઇમદાદ
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type_of_donation"
                  id="jakat"
                  value="jakat"
                  checked={donationData.type_of_donation === 'jakat'}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="jakat">
                  જકાત
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type_of_donation"
                  id="usar"
                  value="usar"
                  checked={donationData.type_of_donation === 'usar'}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="usar">
                  ઉસર
                </label>
              </div>
              {/* <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type_of_donation"
                  id="sadko"
                  value="sadko"
                  checked={donationData.type_of_donation === 'sadko'}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="sadko">
                  સદ્કો
                </label>
              </div> */}
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type_of_donation"
                  id="other"
                  value="other"
                  checked={donationData.type_of_donation === 'other'}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="other">
                  અન્ય
                </label>
              </div>
            </div>
          </div>
          {/* <div className="col-md-3">
            <label className="form-label">Donation Amount (લખાવેલા)</label>
            <input className="form-control" value={donationData.donation_amount} onChange={handleChange} name="donation_amount" placeholder='ટૉટલ લખાવેલ રકમ' />
          </div> */}
          <div className="col-md-3">
            <label className="form-label">Credited Amount (જમા)</label>
            <input className="form-control" value={donationData.credited_amount} onChange={handleChange} name="credited_amount" placeholder='જમા કરેલ રકમ' />
          </div>
          <div className="col-md-3">
            <label className="form-label">Deposit To</label>
            <Select
              value={donationData.depositor}
              name="depositor"
              onChange={handleDepositorChange}
              options={depositorNames}
              placeholder="જમાકર્તા"
            />
          </div>
          <div className="col-12">
            <button className="btn btn-primary btn-lg" onClick={handleUpdate} disabled={loading}>
              {loading ? 'Loading...' : 'Submit'}
            </button>
          </div>
          {/*                         
                <input onChange={(event) => { this.setState({address:event.target.value}) }} placeholder='Enter Address' /><br />
                <input onChange={(event) => { this.setState({rating:event.target.value}) }} placeholder='Enter Rating' /><br />
                <input onChange={(event) => { this.setState({email:event.target.value}) }} placeholder='Enter email' /><br />
                <button onClick={()=>{this.create()}}>Submit</button> */}
        </div>
      </div>
    </div>
  );
};

export default RestaurantUpdate;
